.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--sp-3);
  padding: var(--sp-8) var(--sp-6);
  border: 1px dashed var(--line2);
  border-radius: var(--radius-lg);
  background: var(--surf);
  color: var(--text2);
  text-align: center;
}
.icon {
  font-size: 22px;
  line-height: 1;
}
.title {
  color: var(--text);
  font-size: 13px;
  font-weight: 600;
}
.description {
  max-width: 46ch;
  font-size: 11.5px;
  line-height: 1.6;
}
